/* MYCLUSIV: Slick nur für die tatsächlich vorhandene People-Feedback-Section laden. */
(() => {
  'use strict';

  const config = document.currentScript?.dataset;
  if (!config) return;

  const selector = '.feedback-slider';
  const editor = Boolean(window.Shopify?.designMode);
  if (!editor && !document.querySelectorAll(selector).length) return;

  const assets = new Map();
  let resourcesPromise;
  const pending = new WeakSet();
  const observed = new WeakSet();
  const motionPreference = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const observer = !editor && typeof window.IntersectionObserver === 'function'
    ? new window.IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        observed.delete(entry.target);
        initializeSliders([entry.target]);
      }
    }, { rootMargin: '600px 0px' })
    : null;

  function loadAsset(tag, url) {
    const key = tag + ':' + url;
    if (assets.has(key)) return assets.get(key);

    const promise = new Promise((resolve, reject) => {
      const asset = document.createElement(tag);
      if (tag === 'script') {
        asset.src = url;
        asset.async = true;
      } else {
        asset.rel = 'stylesheet';
        asset.href = url;
      }
      asset.onload = resolve;
      asset.onerror = () => {
        asset.remove();
        assets.delete(key);
        reject(new Error('Feedback-Datei konnte nicht geladen werden.'));
      };
      document.head.appendChild(asset);
    });
    assets.set(key, promise);
    return promise;
  }

  function ensureResources() {
    if (!resourcesPromise) {
      // MYCLUSIV: jQuery vor Slick laden; parallele Sections teilen dieselben Ladungen.
      const styles = loadAsset('link', config.slickStyles);
      const scripts = (window.jQuery ? Promise.resolve() : loadAsset('script', config.jqueryScript))
        .then(() => {
          if (!window.jQuery?.fn) throw new Error('jQuery ist nicht verfügbar.');
          return window.jQuery.fn.slick ? undefined : loadAsset('script', config.slickScript);
        });

      resourcesPromise = Promise.all([styles, scripts])
        .then(() => {
          if (typeof window.jQuery?.fn?.slick !== 'function') {
            throw new Error('Slick ist nicht verfügbar.');
          }
          return window.jQuery;
        })
        .catch(error => {
          resourcesPromise = undefined;
          throw error;
        });
    }
    return resourcesPromise;
  }

  function initializeSliders(candidates) {
    const sliders = candidates.filter(slider => slider.isConnected &&
      !pending.has(slider) && !slider.classList.contains('slick-initialized')
    );
    if (!sliders.length) return;
    sliders.forEach(slider => pending.add(slider));

    ensureResources().then(jQuery => {
      for (const slider of sliders) {
        // MYCLUSIV: Entfernte oder bereits initialisierte Sections überspringen.
        if (!pending.has(slider) || !slider.isConnected || slider.classList.contains('slick-initialized')) continue;

        jQuery(slider).slick({
          autoplay: !motionPreference?.matches,
          dots: false,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          responsive: [
            { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } }
          ]
        });
      }
    }).catch(error => console.warn('[MYCLUSIV] Feedback-Slider:', error.message))
      .finally(() => sliders.forEach(slider => pending.delete(slider)));
  }

  function initialize(root) {
    const sliders = [...root.querySelectorAll(selector)].filter(slider =>
      !slider.classList.contains('slick-initialized') && !pending.has(slider)
    );
    if (!observer) {
      initializeSliders(sliders);
      return;
    }
    // MYCLUSIV: Bibliotheken erst nahe am sichtbaren Bereich laden.
    for (const slider of sliders) {
      if (observed.has(slider)) continue;
      observed.add(slider);
      observer.observe(slider);
    }
  }

  function updateMotionPreference() {
    if (typeof window.jQuery?.fn?.slick !== 'function') return;
    for (const slider of document.querySelectorAll(selector + '.slick-initialized')) {
      window.jQuery(slider).slick('slickSetOption', 'autoplay', !motionPreference.matches, false);
      window.jQuery(slider).slick(motionPreference.matches ? 'slickPause' : 'slickPlay');
    }
  }
  if (motionPreference?.addEventListener) {
    motionPreference.addEventListener('change', updateMotionPreference);
  } else if (motionPreference?.addListener) {
    motionPreference.addListener(updateMotionPreference);
  }

  // MYCLUSIV: custom.js wird mit defer geladen; der Seiteninhalt ist bereits verfügbar.
  initialize(document);

  if (editor) {
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:section:unload', event => {
      for (const slider of event.target.querySelectorAll(selector)) {
        pending.delete(slider);
        if (typeof window.jQuery?.fn?.slick === 'function' && slider.classList.contains('slick-initialized')) {
          window.jQuery(slider).slick('unslick');
        }
      }
    });
  }
})();